export default "__VITE_ASSET__CmxeMlpk__"